import mainAPI from '../api/MainAPI';

class UserGroupSettingsManager {
	constructor() {
		try {
			this.settings = JSON.parse(localStorage.user_group_settings);
		}catch(e) {
			this.settings = []
		}
		this.currentUserGroupId = null;
	}

	refresh = async () => {
		try {
			const userGroupId = localStorage.user_group_id;
			this.settings = await mainAPI.user_group_setting.all({user_group_id: userGroupId});
			localStorage.user_group_settings = JSON.stringify(this.settings);
			return this.settings;
		} catch (error) {
			console.error('Failed to refresh user group settings:', error);
			throw error;
		}
	}

	getSetting = (name) => {
		const setting = this.settings.find(setting => setting.name === name);
		return setting ? setting.value : null;
	}

	upsert = async ({name, value, string_value, user_group_id = null}) => {
		const targetUserGroupId = user_group_id || this.currentUserGroupId;

		if (!targetUserGroupId) {
			throw new Error('User group ID is required for upsert operation');
		}

		const result = await mainAPI.user_group_setting.upsert({
			_user_group_id: targetUserGroupId,
			name,
			value,
			string_value
		});

		const existingSettingIndex = this.settings.findIndex(setting => setting.name === name);
		if (existingSettingIndex >= 0) {
			this.settings[existingSettingIndex].value = value;
		} else {
			this.settings.push({
				user_group_id: targetUserGroupId,
				name,
				value
			});
		}

		return result;
	}
}

const userGroupSettingsManager = new UserGroupSettingsManager();
export default userGroupSettingsManager;



// WEBPACK FOOTER //
// ./src/utils/UserGroupSettingsManager.js